import React,  { Component }  from 'react';
import axios from 'axios';
import {AuthProvider} from "../context/AuthContext";


class Auth extends Component {
	constructor(props) {
    super(props);

		let token = sessionStorage.getItem('accessToken');

		if (token) {
			let user = sessionStorage.getItem('user');
      let roles = sessionStorage.getItem('roles');
      //console.log(roles);
			this.state = {
			    authenticated: true,
			    user: JSON.parse(user),
			    accessToken: token,
          roles: JSON.parse(roles)
  		 };
		} else {
			this.state = {
		    authenticated: false,
		    user: {},
		    accessToken: "",
        roles: {}
		 	};
		}
  }

  jwtlogin = (token) => {
    return axios.get('/ufuser',   {
        headers: { Authorization: token  }
    }).then((res) => {
      if (res.status === 200) {
        return axios.get('/api/user/permissions/' + res.data.user.username, {}).then((res1) =>{
          let user = res.data.user;
          user.DOB = res1.data.DOB;
          let roles = res1.data.permissions;
          this.setState({
              authenticated: true,
              accessToken: token,
              user: user,
              roles: roles
          });
          sessionStorage.setItem('accessToken', token);
          sessionStorage.setItem('user', JSON.stringify(user));
          sessionStorage.setItem('roles', JSON.stringify(roles));
          return res1;
        }).catch(err=>{
          const error = new Error(err);
          throw error;
        });
      }  else {
        const error = new Error(res.error);
        throw error;
      }
    });
  };

  login = (username, password) => {
  	let data = {
  		username: username,
  		password: password
  	}
    return axios.all([
        axios.post('/api/user/authenticate', data),
        axios.get('/api/user/permissions/' + username, {})
    ]).then((res) => {
      if (res[0].status === 200) {
        //store JWT Token to browser session storage to persisted only in current tab
        //console.log(res[0].data.user);
        let user = res[0].data.user;
        user.DOB = res[1].data.DOB;

        console.log(res[1].data.permissions);
        let  roles = res[1].data.permissions;

        //console.log(roles);
        this.setState({
          authenticated: true,
          accessToken: res[0].data.token,
          user: user,
          roles: roles
        });
        sessionStorage.setItem('accessToken', res[0].data.token);
        sessionStorage.setItem('user', JSON.stringify(user));
        sessionStorage.setItem('roles', JSON.stringify(roles));

        return res;
      } else {
        const error = new Error(res[0].error);
        throw error;
      }
  	});
  };

  logout = () => {
    console.log("context logout");
    let saml = (this.state.user && this.state.user.gatorlink) ? true : false;
    console.log("logout" + saml);
    sessionStorage.removeItem("accessToken");
    sessionStorage.removeItem("user");
    sessionStorage.removeItem("roles");
    sessionStorage.removeItem('userTrack');
    // clean up cache
    sessionStorage.removeItem('previousSearch');
    sessionStorage.removeItem('previousSearchData');
    sessionStorage.removeItem('selectedEmployer');
    sessionStorage.removeItem('selectedEmployerMembership');
    sessionStorage.removeItem('adminSelectedEmployer');
    sessionStorage.removeItem('selectedTP');
    sessionStorage.removeItem('selectedProvider');

    console.log(this.props);
    //this.props.history.push('/logoutSAML');
    if (saml) {
        this.setState({
        //  authenticated: false,
          user: {},
          accessToken: "",
          roles: {}
        });
      } else {
        this.setState({
          authenticated: false,
          user: {},
          accessToken: "",
          roles: {}
        });
      }
    
    return saml;

   // if (saml) { 
      // axios.get('/uflogout', {})
      // .catch(err=> {
      //   console.log(err);
      // })
    //} else {
      //    this.props.history.push('/');
   // }
  };

  // update the isTrainee roles for the login user, this could  occur after user purchase a training
  updateIsTrainee = (isTrainee) => {
    console.log("updateTrainee->isTrainee: " + isTrainee);
    let roles = this.state.roles;
    roles.isTrainee = isTrainee;
    console.log("updateTrainee->roles: " + roles);
    sessionStorage.setItem('roles', JSON.stringify(roles));
    this.setState({
       roles: roles
    });
    console.log("updated roles: " + this.state.roles);
  }

  updateUser = async(username) => {
    let token = sessionStorage.getItem('accessToken');
    if (token) {
        let result = await axios.get('/api/user/info/' + username);
        console.log(result.data.user);
        let user1 = result.data.user;
        user1.name = result.data.user.first_name + ' ' +  result.data.user.middle_name + ' ' + result.data.user.last_name;
        user1.gatorlink = this.state.user.gatorlink;
      
        this.setState({
          user: user1
        });
        sessionStorage.setItem('user', JSON.stringify(user1));
    }

  } // refresh user info 

  render() {
    const authProviderValue = {
      ...this.state,
      jwtlogin: this.jwtlogin,
      login: this.login,
      logout: this.logout,
      updateIsTrainee: this.updateIsTrainee,
      updateUser: this.updateUser
    };
    return (
      <AuthProvider value={authProviderValue}>
        {this.props.children}
      </AuthProvider>
    );
  }
}

export default Auth;